import { render } from "./CreateVpc.vue?vue&type=template&id=e98dec42&scoped=true"
import script from "./CreateVpc.vue?vue&type=script&lang=js"
export * from "./CreateVpc.vue?vue&type=script&lang=js"

import "./CreateVpc.vue?vue&type=style&index=0&id=e98dec42&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98dec42"]])

export default __exports__